<app-common-bulk-select-employee-dialog
    #selectEmployees
    headerText="time-tracking.addOrRemoveEmployees"
    [label]="'save' | appTranslate"
    [tooltipTextMaker]="tooltipTextMaker"
    [additionalQueryFilters]="[withTimeTrackingAttributes]"
>
    <p class="text-align-left padding-bottom-3">{{ 'time-tracking.settings.selectEmployees' | appTranslate }}</p>
</app-common-bulk-select-employee-dialog>

<!-- This is a modal that is used to confirm the removal of employees from time tracking. -->
<!-- It needs to work for single removal from the table and removal from the employee select modal. -->
<!-- There are a surprising number of variations, so be careful if changing the logic. -->
<ui-confirmation-dialog
    header="time-tracking.confirmAction"
    [primaryButtonLabel]="removeOrConfirmLabel"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmRemoveModal
>
    <!-- This is the logic for when there is only a single employee. -->
    <ng-container *ngIf="employeesPendingRemoval?.length === 1">
        <ui-banner *ngIf="employeesPendingRemovalWithPendingHours.length" variant="warning" class="margin-bottom-3"
            >{{ 'time-tracking.removeFromTimeTrackingModal.singular.pendingHoursWarning' | appTranslate }}
        </ui-banner>
        <ui-banner *ngIf="projectOwnersPendingRemoval.length" variant="warning" class="margin-bottom-3"
            >{{ 'time-tracking.removeFromTimeTrackingModal.singular.projectOwnerWarning' | appTranslate }}
        </ui-banner>

        <p *ngIf="employeesPendingRemovalWithPendingHours.length">
            {{ 'time-tracking.removeFromTimeTrackingModal.singular.firstIfPendingHours' | appTranslate }}
        </p>
        <p *ngIf="!employeesPendingRemovalWithPendingHours.length">
            {{ 'time-tracking.removeFromTimeTrackingModal.singular.firstIfNoPendingHours' | appTranslate }}
        </p>
        <p>{{ 'time-tracking.removeFromTimeTrackingModal.singular.second' | appTranslate }}</p>
        <p
            [innerHTML]="
                {
                    key: 'time-tracking.removeFromTimeTrackingModal.singular.third',
                    params: { employeeName: employeesPendingRemoval[0].fullName },
                }
                    | appTranslate
                    | sanitizeHtml
            "
        ></p>
    </ng-container>

    <!-- This is the logic for when there is more than one employee. -->
    <ng-container *ngIf="employeesPendingRemoval?.length > 1">
        <ui-banner *ngIf="employeesPendingRemovalWithPendingHours.length" variant="warning" class="margin-bottom-3">
            <div>
                {{
                    {
                        key: 'time-tracking.removeFromTimeTrackingModal.plural.pendingHoursWarning',
                        params: { count: employeesPendingRemovalWithPendingHours.length },
                    } | appTranslate
                }}
                <ul class="margin-0 padding-left-2">
                    <li *ngFor="let employee of employeesPendingRemovalWithPendingHours">{{ employee.fullName }}</li>
                </ul>
            </div>
        </ui-banner>
        <ui-banner *ngIf="projectOwnersPendingRemoval.length" variant="warning" class="margin-bottom-3">
            <div>
                {{
                    {
                        key: 'time-tracking.removeFromTimeTrackingModal.plural.projectOwnerWarning',
                        params: { count: projectOwnersPendingRemoval.length },
                    } | appTranslate
                }}
                <ul class="margin-0 padding-left-2">
                    <li *ngFor="let employee of projectOwnersPendingRemoval">{{ employee.fullName }}</li>
                </ul>
            </div>
        </ui-banner>
        <p>{{ 'time-tracking.removeFromTimeTrackingModal.plural.first' | appTranslate }}</p>
        <p>{{ 'time-tracking.removeFromTimeTrackingModal.plural.second' | appTranslate }}</p>
        <p>{{ 'time-tracking.removeFromTimeTrackingModal.plural.third' | appTranslate }}</p>
    </ng-container>
</ui-confirmation-dialog>

<ui-dialog
    [open]="showAtLeastOneAdminModal"
    (closing)="showAtLeastOneAdminModal = false"
    header="time-tracking.settings.atLeastOneAdminNeeded.title"
    primaryButtonLabel="close"
    (primaryButtonPressed)="showAtLeastOneAdminModal = false"
>
    <p>{{ 'time-tracking.settings.atLeastOneAdminNeeded.body1' | appTranslate }}</p>
    <p>{{ 'time-tracking.settings.atLeastOneAdminNeeded.body2' | appTranslate }}</p>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="{{ 'time-tracking.indexProjectsPage.title' | appTranslate }}" [menuService]="menuService">
    </app-header>

    <app-time-tracking-general-settings-card *ngIf="isOnTimeTracking"></app-time-tracking-general-settings-card>

    <app-time-tracking-approval-flow-settings *ngIf="isOnTimeTracking"></app-time-tracking-approval-flow-settings>

    <app-payroll-integration-card *ngIf="isOnTimeTracking && isOnPayroll"></app-payroll-integration-card>

    <ui-card>
        <app-segment-header title="time-tracking.assignedEmployees"> </app-segment-header>

        <!-- This combination of values allows for a table to be displayed correctly within a segment. -->
        <app-table
            *ngIf="employeesOnTimeTracking.length"
            [table]="table"
            (menuItemSelected)="menuAction($event)"
            [embedded]="true"
            [showOffset]="false"
            [noPadding]="true"
            [showActionsPadding]="false"
            [useStickyHeader]="false"
            [showLoading]="false"
        >
        </app-table>
        <p class="neutral-dark" *ngIf="employeesOnTimeTracking.length === 0">
            {{ 'time-tracking.noEmployeesAssignedToTimeTracking' | appTranslate }}
        </p>
        <ui-button (click)="openEmployeeSelect()" type="primary">{{
            'time-tracking.addOrRemoveEmployees' | appTranslate
        }}</ui-button>
    </ui-card>
</div>
